type AnalyticsProvider = {
  capture: (event: string, properties?: Record<string, unknown>) => void;
};

let provider: AnalyticsProvider | null = null;

export const initAnalytics = (analyticsProvider: AnalyticsProvider): void => {
  provider = analyticsProvider;
};

export const sendEvent = (
  event: string,
  properties: Record<string, unknown>,
): void => {
  provider?.capture(event, properties);
};
